import React from "react";
import logo from "client/onpoint/client-logo.svg";
import svglogo from "client/onpoint/ClientLogo";
import clientOnlyResources from ".";
import theme from "client/onpoint/theme";
import HistoryIcon from '@mui/icons-material/History';
import { 
  fullFeatureList,
  storeAttrOptions,
  storeGroupByOptions,
  itemAttrOptions,
  storeFilterOptions,
  itemGroupColumnOptions,
  runtimeItemGroupFilterOptions
} from 'client/onpoint/hardcoded_features'
// import PatronPointsUserRegistration from 'client/onpoint/PatronPointsRegistration'
// import ArrowIcon from '@mui/icons-material/TrendingFlat';
import NRSIcon from '@mui/icons-material/DesktopWindows';
import LocalConvenienceStoreIcon from "@mui/icons-material/LocalConvenienceStore";

import PatronPointsUserRegistration from './PatronPointsRegistrationWizard'


// import SVGLogo from ''
// retries for lazy components... 
// https://dev.to/goenning/how-to-retry-when-react-lazy-fails-mb5
function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}

export const master_store_report_group_by_options = [
  {
    id: 10,
    name: "onpoint_chain",
  },
  {
    id: 11,
    name: "broker_chain",
  },
  
];

export const master_store_report_attribute_options = [
  {
    id: 1,
    name: "onpoint_chain_id",
  },
  {
    id: 2,
    name: "onpoint_chain",
  },
];

export const master_store_report_filter_definitions = [
 
];


const AuthorizedSupplierSources = [
  { id: "DST", name: "DST" },
];

// Used in dashboard building/deploy interfaces:
// This function determines what deployment targets to show depending on
// the available attributes in the report suite data.
// If the dimension is not available in the incoming dimensionColumns array
// the attribute is not available in the report and cannot be used as a deploy target
// list of dashboard deployment targets used by the
// dashboard deployment to separate targets into tabs
//
// [
//   {
//     id: <name of resource to target>,
//     name: <label displayed as Tab Name>
//   }
// ]
const deployTargetTabs = [
  { id: "main_dashboard", name: "Main Dashboard" }, // default - main dashboard
  { id: "brand_id", name: "Items" }, // default - item level page
  {
    id: "distributor",
    name: "Distributors",
    dimension: "distributor_name",
    targetConfig: {
      resource_name: "onpoint_distributor",
      name: "Distributor",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "warehouse_name@eq",
    },
  }, 
  {
    id: "manufacturer_name",
    name: "Manufacturer",
    dimension: "infobate_manufacturer",
    targetConfig: {
      resource_name: "onpoint_manufacturers",
      name: "manufacturer",
      column_defs: [{ id: 50 }, { name: 350 }],
      filter_column: "manufacturer_name@eq",
    },
  },
  {
    id: "master_chain",
    name: "Chains",
    dimension: "onpoint_chain",
    targetConfig: {
      resource_name: "master_chain",
      name: "Chain",
      column_defs: [{ id: 50 }, { primary_name: 350 }],
      filter_column: "onpoint_chain@eq",
    },
  }, // default - chain page
];

// User roles that are available for this client
//
const userRoles = [
  { id: "onpoint", name: "OnPoint" },
  { id: "onpoint_admin", name: "OnPoint Admin" },
  { id: "site_admin", name: "Site Admin" },
  { id: "wam_onpoint_admin", name: "WAM OnPoint Admin" },
];

const customRoutes = [
  {
    path: "/extraction_software_registration",
    component: PatronPointsUserRegistration,
    // allowedRoles: ["kelloggs_admin", "site_admin"],
    noLayout: true
  },
];

// Extra menu customization for client specific resources
// This object extends the default menu choices allowing
// side menu links to resources that do not exist for anyone but client
// Submenu placement is determined by config under either menuCustomer, menuItem, and menuFiles keys (Customer, Item, Files respectively).
// Only those three top level menues can be extended currently.
// Permissions can be used to determine menu visibility to a role
// but underlying permissions to the resource will still be enforced on
// the HTTP APIs
const menuCustomization = {
  menuCustomer: [
    {
      // side menu link for 
      to: `/onpoint_store_status_log`,
      label: "Store Status Log",
      icon: <HistoryIcon />,
      featureTag: 'store_status_log',
      allowedRoles: ['onpoint', 'onpoint_admin', 'site_admin', 'wam_onpoint_admin'],
    },

  ],
  menuItem: [
   
  ],
  menuFiles: null,
  sourceMenu: [
    {
      // side menu link for 
      to: `/onpoint_patron_points_stores`,
      label: "Patron Stores",
      icon: <LocalConvenienceStoreIcon />,
      allowedRoles: ['onpoint', 'onpoint_admin', 'site_admin', 'wam_onpoint_admin'],
    },
    // {
    //   // side menu link for 
    //   to: `/onpoint_choctaw_stores`,
    //   label: "Choctaw Stores",
    //   icon: <ArrowIcon />,
    //   allowedRoles: ['onpoint', 'onpoint_admin', 'site_admin', 'wam_onpoint_admin'],
    // },
    {
      // side menu link for 
      to: `/onpoint_nrs_stores`,
      label: "NRS Stores",
      icon: <NRSIcon />,
      allowedRoles: ['onpoint', 'onpoint_admin', 'site_admin', 'wam_onpoint_admin'],
    }
  ]
};

// Client overrides of default pages.
// Used when client has customized attribution and business rules which
// cannot be addressed in the default views (infobate only attribution)
const customPages = {
  master_chain: {
    edit: null,
    list: null,
  },
  master_customers: {

    // edit: null,
    // list: null,
    edit: React.lazy(() =>
      retry(() => import("./master_customers/Edit"))
    ),
    list: React.lazy(() =>
      retry(() => import("./master_customers/List"))
    ),
  },
  master_items: {

    edit: React.lazy(() =>
        retry(() => import("./master_items/Edit"))
      ),
    list: React.lazy(() =>
      retry(() => import("./master_items/List"))
    ),
  },
};

const dashboardConfig = {
  dimensions: {},
  sunburstHierarchies: {
    "Distributor/Warehouse": ["distributor_name", "warehouse_name"]
  },
};

const appConfig = {
  CLIENT_NAME_LABEL: "OnPoint",
  CLIENT_NAME: "onpoint",
  CLIENT_LOGO: logo,
  APP_BAR_LOGO: svglogo,
  AUTH_SUPPLIER_SOURCES: AuthorizedSupplierSources,
  USER_ROLES: userRoles,
  CLIENT_CUSTOM_ROUTES: customRoutes,
  EXTRA_MENUS: menuCustomization,
  CUSTOM_PAGES: customPages,
  DASHBOARD_CONFIG: dashboardConfig,
  // DIMENSION_CHOICES: dimensionChoices,
  DEPLOY_TARGET_TABS: deployTargetTabs,
  CUSTOM_RESOURCES: clientOnlyResources,
  CLIENT_THEME: theme,
  BACKGROUND_IMAGE: "bg.jpg",
  routeOverrides: {},
  REPORTING_OPTIONS: {
    storeAttrOptions,
    storeGroupByOptions,
    itemAttrOptions,
    storeFilterOptions,
    itemGroupColumnOptions,
    runtimeItemGroupFilterOptions,
    reportAvailability: {
      "Period Comparison": true,
      "Period Comparison Store Level": true,
      "Fact Summary": true,
      "Store Rows/Item Columns Pivot": true,
      "Store Group Rows/Item Columns Pivot": true,
      "Store Rows/Item Columns Pivot (No Item Groups)": true,
      "Item Group Summary": true,
      "ACV by Store Group And Period": true,
    },
    calendarFormat: "445"
  },

  featureList: fullFeatureList,
};

export default appConfig;
